import React, { useEffect, useState } from 'react';
import styles from './WalletModal.module.scss';
import Modal from '../Modal/Modal';
import { useModalStore } from '@/store/ModalStore';
import { TelegramSticker } from '@/components/TelegramSticker';
import { getBalance, postBalance } from '@/api/modules/User/balance';
import { ReactComponent as StarIcon } from '@/assets/Icons/star.svg';
import { useNotificationStore } from '@/store/NotificationStore';

interface WalletModalProps {
  open: boolean;
  onClose: () => void;
}

const WalletModal: React.FC<WalletModalProps> = ({ open, onClose }) => {
  const tg = window?.Telegram?.WebApp;
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );
  const [balance, setBalance] = useState(0);
  useEffect(() => {
    if (open) {
      getBalance().then((response) => {
        setBalance(response.data.amount);
      });
    }
  }, [open]);
  if (!open) return null;

  const handleWithdraw = async () => {
    if (balance < 15) {
      setNotification({
        type: 'Warning',
        message: 'Вывод доступен от 15 звезд',
      });
      return;
    }
    try {
      await postBalance();
      tg?.close();
    } catch (error: any) {
      if (
        error.response &&
        error.response.status === 403 &&
        error.response.data.detail === 'Withdrawal application already exists'
      ) {
        setNotification({
          type: 'Warning',
          message: 'Ваш запрос на вывод уже создан, ожидайте, пожалуйста.',
        });
      } else {
        setNotification({
          type: 'Error',
          message: 'Ошибка при отправке запроса на вывод.',
        });
      }
    }
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.walletModal}>
        <h2 className={styles.title}>Вывод звезд</h2>
        <div className={styles.stickerWrapper}>
          <TelegramSticker
            tgsUrl="./money.tgs"
            style={{ width: 160, height: 160 }}
            loop={false}
            autoplay={true}
          />
        </div>

        <div className={styles.balanceInfo}>
          <div className={styles.balanceItem}>
            <span className={styles.value}>
              {' '}
              {balance.toString().replace('.', ',')} <StarIcon />{' '}
            </span>
          </div>
        </div>
        <p className={styles.description}>Срок обработки заявки до 24 часов.</p>
        <button className={styles.withdrawButton} onClick={handleWithdraw}>
          Вывести
        </button>
      </div>
    </Modal>
  );
};

export default WalletModal;
